<script>
  // Drop-in wrapper that requires the current Auth0 session to be authenticated.
  // Unauthenticated visitors are redirected to /login (preserving the page they
  // were trying to reach via the appState mechanism in lib/auth.js).
  //
  // Use like:
  //   <AuthGuard>
  //     <YourPage />
  //   </AuthGuard>

  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { isAuthenticated, isLoading, login } from '../auth.js';

  // TODO: server-side loader removed — the legacy SvelteKit
  // (authenticated)/+layout.js also performed a per-route role gate against a
  // roleRequirements map. Port that role-based access check into AuthGuard
  // (or a sibling RoleGuard) when re-implementing on Spring Boot.

  let allow = false;
  let checking = true;

  onMount(async () => {
    // Wait for the loading flag to settle, then decide.
    const unsubLoading = isLoading.subscribe((loading) => {
      if (!loading) {
        const unsubAuth = isAuthenticated.subscribe((authed) => {
          if (authed) {
            allow = true;
            checking = false;
          } else {
            checking = false;
            // Try silent login first via redirect; if that fails (no SSO
            // session) the user lands on Auth0 hosted login.
            const returnTo = window.location.pathname + window.location.search;
            login(returnTo).catch(() => navigate('/login', { replace: true }));
          }
        });
        // Settle once.
        unsubAuth();
      }
    });
    // Settle once.
    unsubLoading();
  });
</script>

{#if checking}
  <div class="auth-guard-checking">
    <p>Checking session…</p>
  </div>
{:else if allow}
  <slot />
{:else}
  <div class="auth-guard-blocked">
    <p>Redirecting to sign-in…</p>
  </div>
{/if}

<style>
  .auth-guard-checking,
  .auth-guard-blocked {
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: system-ui, -apple-system, sans-serif;
    color: #555;
  }
</style>
